var youboralib = require('youboralib')

module.exports = {
  isUsed: function (adapter) {
    return !!adapter.getTech().hls_
  },

  getResource: function (adapter) {
    var ret = null
    if (adapter.getTech().hls_ && adapter.getTech().hls_.url) {
      ret = adapter.getTech().hls_.url
    } else if (adapter.getTech().hls && adapter.getTech().hls.source_) {
      ret = adapter.getTech().hls.source_.src
    }
    return ret
  },

  getBitrate: function (adapter) {
    var ret = null
    var currentLevel = adapter.getTech().hls_.currentLevel
    if (typeof currentLevel !== 'undefined' && currentLevel !== -1 && !!adapter.getTech().hls_.levels) {
      var level = adapter.getTech().hls_.levels[currentLevel]
      if (level && level.bitrate) {
        ret = level.bitrate
      }
    }
    return ret
  },

  getRendition: function (adapter) {
    var ret = null
    var currentLevel = adapter.getTech().hls_.currentLevel
    if (typeof currentLevel !== 'undefined' && currentLevel !== -1 && !!adapter.getTech().hls_.levels) {
      var level = adapter.getTech().hls_.levels[currentLevel]
      if (level) {
        ret = youboralib.Util.buildRenditionString(level.width, level.height, level.bitrate)
      }
    }
    return ret
  }
}
